function formatMoney(cents) {
  return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
}

function currentQuantity(card) {
  var input = card.querySelector('.quantity-selector input[name="quantity"]');
  var value = input ? parseInt(input.value, 10) : 1;
  return isNaN(value) || value < 1 ? 1 : value;
}

// Werkt zowel prijs als doorgestreepte vanafprijs bij, telkens
// vermenigvuldigd met het huidige aantal — zodat ze meebewegen met de
// quantity-stepper, niet alleen met een variant-wissel.
function updateTotal(card) {
  var totalEl = card.querySelector('.product-hero__total-price');
  var compareEl = card.querySelector('.product-hero__total-compare');
  var unitPrice = parseInt(card.dataset.unitPrice, 10);
  var comparePrice = parseInt(card.dataset.comparePrice, 10) || 0;
  if (isNaN(unitPrice)) return;

  var quantity = currentQuantity(card);

  if (totalEl) totalEl.textContent = formatMoney(unitPrice * quantity);

  if (compareEl) {
    if (comparePrice > unitPrice) {
      compareEl.textContent = formatMoney(comparePrice * quantity);
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }
}

// "Direct bestellen" linkt naar een cart permalink (/cart/{variant}:{qty}),
// niet naar /products/.../checkout — dat laatste bestaat niet als Shopify-route.
function updateBuyNowHref(card) {
  var buyNowEl = card.querySelector('.product-hero__buynow');
  if (!buyNowEl) return;
  var base = buyNowEl.dataset.cartBaseUrl;
  var variantId = buyNowEl.dataset.variantId;
  if (!base || !variantId) return;
  buyNowEl.setAttribute('href', base + '/' + variantId + ':' + currentQuantity(card));
}

// De +/- knoppen zetten quantityInput.value rechtstreeks via JS (geen native
// input/change-event) en dispatchen in plaats daarvan quantity-selector:update.
// Handmatig typen + blur loopt via dezelfde event, dus dit dekt beide paden.
document.addEventListener('quantity-selector:update', function (event) {
  if (!(event.target instanceof Element)) return;
  var card = event.target.closest('.product-hero__card');
  if (!card) return;
  updateTotal(card);
  updateBuyNowHref(card);
});

// Mobiele sticky add-to-cart-balk: verschijnt zodra de echte ATC-knop
// boven de viewport scrolt, verdwijnt weer zodra hij terug in beeld is.
// De balk klikt de echte knop aan (geen eigen submit-logica) zodat hij
// altijd de actuele form-state gebruikt.
function setupStickyAddToCart(section) {
  var atcButton = section.querySelector('.product-hero__atc');
  var stickyBar = section.querySelector('.product-hero__sticky-atc');
  if (!atcButton || !stickyBar) return;

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      var scrolledPastAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', scrolledPastAbove);
      stickyBar.setAttribute('aria-hidden', scrolledPastAbove ? 'false' : 'true');
    },
    { threshold: 0 }
  );
  observer.observe(atcButton);

  var stickyButton = stickyBar.querySelector('.product-hero__sticky-atc-button');
  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      atcButton.click();
    });
  }
}

document.querySelectorAll('.product-hero').forEach(function (section) {
  setupStickyAddToCart(section);
});

document.addEventListener('shopify:product:select', function (event) {
  if (!(event.target instanceof Element) || !event.promise) return;
  var card = event.target.closest('.product-hero__card');
  if (!card) return;

  event.promise
    .then(function (result) {
      var variant = result && result.detail && result.detail.resource;
      if (!variant) return;

      var price = variant.price;
      var compare = variant.compare_at_price || 0;
      var name = variant.title || '';
      var available = variant.available !== false;

      var infoNameEl = card.querySelector('.product-hero__variant-info-name');
      var infoPriceEl = card.querySelector('.product-hero__variant-info-price');
      var infoCompareEl = card.querySelector('.product-hero__variant-info-compare');
      var buyNowEl = card.querySelector('.product-hero__buynow');
      var atcEl = card.querySelector('.product-hero__atc');
      var section = card.closest('.product-hero');
      var stickyPriceEl = section ? section.querySelector('.product-hero__sticky-atc-price') : null;
      var stickyButtonEl = section ? section.querySelector('.product-hero__sticky-atc-button') : null;

      if (infoNameEl) infoNameEl.textContent = name;
      if (infoPriceEl && !isNaN(price)) infoPriceEl.textContent = formatMoney(price);
      if (infoCompareEl) {
        if (compare > price) {
          infoCompareEl.textContent = formatMoney(compare);
          infoCompareEl.style.display = '';
        } else {
          infoCompareEl.style.display = 'none';
        }
      }

      if (!isNaN(price)) {
        card.dataset.unitPrice = price;
        card.dataset.comparePrice = compare;
        updateTotal(card);
      }

      if (buyNowEl && variant.id) {
        buyNowEl.dataset.variantId = variant.id;
        updateBuyNowHref(card);
      }

      if (atcEl) atcEl.disabled = !available;
      if (stickyPriceEl && !isNaN(price)) stickyPriceEl.textContent = formatMoney(price);
      if (stickyButtonEl) stickyButtonEl.disabled = !available;
    })
    .catch(function () {});
});
